import { ApplicationApiTagTypes, ApplicationApiUrls } from "@/modules/application/common/enum";
import type {
  IAccountOpeningApplication,
  ICreateAccountOpeningApplicationRequest,
  IUpdateAccountOpeningApplicationRequest,
} from "@/modules/application/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const accountOpeningApplicationApi = createApi({
  reducerPath: "accountOpeningApplicationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [ApplicationApiTagTypes.ApplicationHistory],
  endpoints: (builder) => ({
    createAccountOpeningApplication: builder.mutation<string, ICreateAccountOpeningApplicationRequest>(
      withIdempotency<ICreateAccountOpeningApplicationRequest>(
        ApplicationApiUrls.AccountOpening,
      )),
    updateAccountOpeningApplication: builder.mutation<string, IUpdateAccountOpeningApplicationRequest>(
      {
        query: ({ data, id }) => ({
          url: `${ApplicationApiUrls.AccountOpening}/${id}`,
          method: "PUT",
          data,
        }),
      }),
    getAccountOpeningApplication: builder.query<IAccountOpeningApplication, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${ApplicationApiUrls.AccountOpening}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetAccountOpeningApplicationQuery,
  useCreateAccountOpeningApplicationMutation,
  useUpdateAccountOpeningApplicationMutation,
} = accountOpeningApplicationApi;
